import React from 'react';
import { TranslationKey } from '../i18n/translations';
interface EditorProps {
  markdown: string;
  onChange: (value: string) => void;
  isDark: boolean;
  t: (key: TranslationKey) => string;
}
export function Editor({
  markdown,
  onChange,
  isDark,
  t
}: EditorProps) {
  return <div className={`flex-1 rounded-2xl shadow-sm flex flex-col overflow-hidden ${isDark ? 'bg-[#242830]' : 'bg-white'}`} data-id="element-24" data-mp="2lmcxvgwgmw4l">
      <div className={`px-8 py-4 border-b ${isDark ? 'bg-[#2d3340] border-[#3a3f4a]' : 'bg-[#fafafa] border-[#e8ecf0]'}`} data-id="element-25" data-mp="2qkeelv6eyjcw">
        <h2 className={`text-sm font-light tracking-wide ${isDark ? 'text-[#7b92a8]' : 'text-[#5b7c8d]'}`} data-id="element-26" data-mp="2vmnb31ihw3jr">
          {t('editor.title')}
        </h2>
      </div>
      <textarea value={markdown} onChange={e => onChange(e.target.value)} className={`flex-1 p-8 font-mono text-sm resize-none focus:outline-none ${isDark ? 'bg-[#242830] text-[#e8ecf0] placeholder-[#5a6270]' : 'bg-white text-[#4a5568] placeholder-[#9ca3af]'}`} placeholder={t('editor.placeholder')} spellCheck={false} style={{
      lineHeight: '1.8'
    }} data-id="element-27" data-mp="34kp7f3raa80p" />
    </div>;
}